class CarolineLibrarySessionError extends Error {
    constructor(message) {
        super(message);
        this.name = 'CarolineLibrarySessionError';
    }
}

module.exports = { CarolineLibrarySessionError };
